<template>
  <div>
    <form role='form'>
      <div class='modal-body'>
        <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
          <ul>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' v-if='successShow'>
          تم إفراغ الايصالات بنجاح!
        </div>
        <fieldset>
          <div class='form-group col-lg-12 col-sm-12'>
            <label>الفرع:</label>
            <select class="form-control"  v-model="branch_id" >
              <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='form-group col-lg-12 col-sm-12'>
            <tbDate :today='today' :mytitle='folderDateTitle' v-model= 'folderDate' ></tbDate>
          </div>
          <div class='col-lg-12 col-md-12 col-sm-12'>
            <label>المحصل/الفنى:</label>
          <div class="form-group input-group">
            <span class="input-group-btn">
              <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                <button
                  @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                </button>
            </span>
            <select class="form-control" style="padding: 0px" v-model="collector_id">
              <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                {{ collector.name }}
              </option>
            </select>
            </div>
          </div>
        </fieldset>
      </div>
      <div class='modal-footer'>
        <vue-element-loading size='32' :active='isLoadingData' spinner='spinner' color='#A4A4A4'/>
        <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
        <button @click='emptyData()' type='button' class='btn btn-primary'>إفراغ</button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'ResetReceipt',
  data () {
    return {
      isgetTec: false,
      today: true,
      branches: {},
      branch_id: 0,
      collectors: '',
      collector_id: null,
      isLoadingData: false,
      validationErrors: null,
      successShow: null,
      folderDateTitle: 'تاريخ الحافظة',
      folderDate: '',
      isLoadingSave: false,
      CollectorsSuccess: ''
    }
  },
  methods: {
    pageLoad () {
      this.successShow = false
      this.validationErrors = null
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    },
    // ========================================================
    getTec () {
      this.isgetTec = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'get-folder-tec', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        folder_date: this.folderDate
      })
        .then(({ data }) => {
          this.collectors = data
          this.isgetTec = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.isgetTec = false
          this.validationErrors = err.response.data.errors
        })
    },
    // ===========================================================
    emptyData () {
      this.isLoadingData = true
      this.successShow = false
      this.validationErrors = null
      axios.post(this.$apiURL + 'empty-tec-receipt', {
        token: localStorage.getItem('token'),
        folder_date: this.folderDate,
        collector_id: this.collector_id
      })
        .then(res => {
          this.isLoadingData = false
          this.successShow = true
        })
        .catch(err => {
          this.isLoadingData = false
          this.validationErrors = err.response.data.errors
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ResetReceipt.vue